import { useEffect, useRef } from "react";

export const SectionVideo = ({ src, srcMobile, poster, opacity = 0.18, testid }) => {
  const ref = useRef(null);
  const chosenSrc =
    srcMobile && typeof window !== "undefined" && window.matchMedia("(max-width: 640px)").matches ? srcMobile : src;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid={testid}>
      <video
        ref={ref}
        poster={poster}
        muted
        loop
        playsInline
        preload="none"
        className="h-full w-full object-cover"
        style={{ opacity }}
      >
        <source src={chosenSrc} type="video/mp4" />
        <source src={src.replace(/\.mp4$/, ".webm")} type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-ink/60" />
    </div>
  );
};
